import { render, staticRenderFns } from "./import-detail.vue?vue&type=template&id=28890c48&"
import script from "./import-detail.vue.ts?vue&type=script&lang=ts&"
export * from "./import-detail.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports